import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import { PageHeader } from './index';
import { DesktopPageHeader } from '../../../styled/pageLayout.styles';
import { HeaderTitle } from './styled';
import useScreenSize from '../../../hooks/useScreenSize';
import { useClient } from '../../../hooks/useClient';
import { BackHistoryStorage } from '../../../utils/helpers/BackHistoryStorage';

interface AdaptivePageHeaderProps {
  title: string;
  type: string;
  isResidencePage?: boolean;
  hasFilters?: boolean;
  pageHeaderDirection?: 'column' | 'row';
}
export const AdaptivePageHeader: React.FC<
  React.PropsWithChildren<AdaptivePageHeaderProps>
> = ({
  title,
  type,
  isResidencePage = false,
  children,
  hasFilters = true,
  pageHeaderDirection = 'column'
}) => {
  const router = useRouter();
  const { isSmall } = useScreenSize();
  const isClient = useClient();

  const goBack = useCallback(() => {
    const hasHistory = BackHistoryStorage.getBackHistoryStorage();

    if (hasHistory) router.back();
    else router.push('/');
  }, [router]);

  const showMobileHeader = (isSmall && isClient) || !isClient;
  const showDesktopTitle = (!isSmall && isClient) || !isClient;
  return (
    <>
      {showMobileHeader && (
        <PageHeader
          id="page_header"
          title={title}
          backButtonCypress={`${type}-header-btn-close`}
          titleCypress={`${type}-page-title`}
          onClick={goBack}
          showHeaderBorder={false}
          headerTag="h1"
        />
      )}
      {(hasFilters || (!hasFilters && showDesktopTitle)) && (
        <DesktopPageHeader
          $isResidencePage={isResidencePage}
          $showDesktopTitle={hasFilters}
          $direction={pageHeaderDirection}
        >
          {showDesktopTitle && (
            <HeaderTitle data-cy={`${type}-page-title`} tag="h1">
              {title}
            </HeaderTitle>
          )}
          {children}
        </DesktopPageHeader>
      )}
    </>
  );
};
